import { FC } from 'react';

import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';
import TableSkeleton from 'modules/_shared/components/Tables/TableSkeleton';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';
import NotesSectionTable from './NotesSectionTable';
import { useNotesSection } from '../context/NotesSectionContext';

const NotesSectionBody: FC = () => {
  const { data, actions } = useNotesSection();

  const showPagination = data.notes && data.notesTotal > 10;

  return (
    <div className="mt-4">
      {data.isLoadingNotes ? (
        <TableSkeleton
          rows={10}
          columns={3}
          showSubHeader={false}
          cardInner={false}
        />
      ) : (
        <NotesSectionTable />
      )}

      {showPagination && (
        <TablePagination
          totalRows={data.notesTotal || 0}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </div>
  );
};
export default NotesSectionBody;
